export default {
  IsStartWithNumber(input) {
    const startNumberExp = /^\d/;
    return startNumberExp.test(input);
  },
  IsHaveThaiText(input) {
    const thRegExp = /[กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุูเแโใไๅๆ็่้๊๋์]/;
    return thRegExp.test(input);
  },

  TrunecateText(text, length = 0) {
    if (!text) return "";
    return text.toString().substring(0, length);
  },
  RemoveAllNonNumericCharacters(str) {
    if (!str) return "";
    return str.replace(/[^\d.]/g, "");
  },
};
